/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { DxpScreenBanner } from 'apps/console-core/src/Components/DxpScreenBanner/DxpScreenBanner';
import { DxpScreenBannerProps } from 'apps/console-core/src/Components/DxpScreenBanner/DxpScreenBanner.props';
import clsx from 'clsx';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { INSTANCE_MANAGEMENT_STRINGS } from '../../Constants/Strings.constants';
import { ProductInstanceBannerProps } from './ProductInstanceBanner.props';

/**
 * Product instance banner.
 */
export const ProductInstanceBanner = (props: ProductInstanceBannerProps): JSX.Element => {
  const { classes, icon, title }: ProductInstanceBannerProps = props;
  const { t } = useTranslation();

  // Labels
  const labels = useMemo(() => {
    return {
      contactCustomerSuccess: t(INSTANCE_MANAGEMENT_STRINGS.contactCustomerSuccess),
    };
  }, [t]);

  const description = <p>{labels.contactCustomerSuccess}</p>;

  const bannerClass = clsx(`product-instance-banner`, classes);
  const dxpScreenBannerProps: DxpScreenBannerProps = {
    classes: bannerClass,
    description,
    icon,
    title,
  };

  return <DxpScreenBanner {...dxpScreenBannerProps} />;
};
